import axios from '@/libs/axios'

export default {
  getOrderRequests: params => axios.get('/partner/order-requests', { params }),
  getOrderRequestStatusTotals: params => axios.get('/partner/order-requests/status-totals', { params }),
  getOrderRequestById: id => axios.get(`/partner/order-requests/${id}`),
  getAllowedCustomers: () => axios.get('/partner/order-requests/allowed-customers'),
  createOrderRequest: payload => axios.post('/partner/order-requests', payload),
  updateOrderRequest: (id, payload) => axios.patch(`/partner/order-requests/${id}`, payload),
  submitOrderRequest: id => axios.post(`/partner/order-requests/${id}/submit`, {}),
  cancelOrderRequest: id => axios.post(`/partner/order-requests/${id}/cancel`, {}),
}
